import React from "react";
import { useParams, Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BackToTop from "../components/BackToTop";
import { directorsData } from "../data/directorsData";
import "../css/DirectorDetailPage.css";

const DirectorDetailPage = () => {
  const { slug } = useParams();
  const director = directorsData[slug];

  if (!director) {
    return (
      <>
        <Header />
        <div className="director-detail-error">
          <p>Director not found.</p>
          <Link to="/board-of-directors">Back to Board of Directors</Link>
        </div>
        <Footer />
        <BackToTop />
      </>
    );
  }

  const { name, title, image, descriptionLong } = director;

  return (
    <>
      <Header />

      <div className="director-detail-wrapper">
        <div className="center-container">
          {/* Breadcrumb */}
          <div className="breadcrumbs">
            <Link to="/">Home</Link> &gt;{" "}
            <Link to="/board-of-directors">Board of Directors</Link> &gt;{" "}
            <span>{name}</span>
          </div>

          {/* Dark name banner */}
          <div className="director-name-banner">
            <h1>{name}</h1>
            <p
              className="director-banner-title"
            >
              {title}
            </p>
          </div>

          <div className="director-detail-container">
            <div className="director-detail-image">
              <img src={image} alt={name} />
            </div>
            <div className="director-detail-content">
              <h2>{name}</h2>
              <p className="director-detail-title">{title}</p>
              <hr className="director-detail-hr" />
              <div
                className="director-detail-description"
                dangerouslySetInnerHTML={{ __html: descriptionLong }}
              />
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <BackToTop />
    </>
  );
};

export default DirectorDetailPage;
